import listStyles from "./List.module.scss"; // Add your own styling
import utilityStyles from "styles/modules/Utility.module.scss";


const List = ({
  data,
  customStyle = {},
}) => {

  return (
    <div className={`${customStyle}`}>
      {data.map((item, idx) => (
        <div key={idx} className={`${utilityStyles.flexColumn} ${listStyles.dataItem}`}>
          <p>{item.label}:<strong> {item.value} </strong></p>
        </div>
      ))}
    </div>
  );
};

export default List;
